/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Ratio_LabelInputs */



/**
* | output |
* | --- |
* | "Ratio" |
*
* @param {Audio_Description_Export_Automix_Ratio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_ratio_label = /** @type {((inputs?: Audio_Description_Export_Automix_Ratio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Ratio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ratio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verhältnis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rapporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Соотношение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("比率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("比率")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुपात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Razão")
	return /** @type {LocalizedString} */ ("Ratio")
});